<template>
  <GlobalHeader />
  <main>
    <slot />
  </main>
  <GlobalFooter />
</template>

<script lang="ts" setup>
const siteStore = useSiteStore();
const siteCfg = siteStore.siteConfig;

if (siteCfg?.elements?.favicon?.value.length > 0) {
  useHead({
      link: [{ rel: 'icon', type: 'image/x-icon', href: siteCfg.elements.favicon.value[0]!.url }],
  });
}
</script>